<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="分类名称">
                  <el-input  v-model="queryForm.categoryName"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppDictCategoryList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppDictCategory"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppDictCategory(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppDictCategory(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportMppDictCategoryList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshMppDictCategoryList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppDictCategoryList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="categoryName"
        label="分类名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="categoryDesc"
        label="分类描述"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppDictCategory(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppDictCategory(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMppDictCategory(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppDictCategoryStates[mppDictCategoryState]"
      :visible.sync="showDialog"
      width="400px"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="mppDictCategory"
          ref="mppDictCategoryForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="分类名称"
            prop="categoryName"
          >
            <el-input
              size="small"
              v-model="mppDictCategory.categoryName"
              :disabled="mppDictCategoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="分类描述"
            prop="categoryDesc"
          >
            <el-input
              size="small"
              v-model="mppDictCategory.categoryDesc"
              :disabled="mppDictCategoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              v-model="mppDictCategory.sort"
              :disabled="mppDictCategoryState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppDictCategoryState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppDictCategoryList();
                    this.getMppDictCategoryList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppDictCategoryList();
                    this.getMppDictCategoryList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     categoryName: '', //分类名称
                     categoryDesc: '', //分类描述
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppDictCategoryState: 'add',
                mppDictCategoryStates: {
                    add: '新建字典分类',
                    check: '查看字典分类',
                    edit: '修改字典分类'
                },

                multipleSelection: [],
                mppDictCategoryList: [],
                mppDictCategory: {
                    id: '', //ID
                    categoryName: '', //分类名称
                    categoryDesc: '', //分类描述
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    categoryName: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }],
                    categoryDesc: [{ required: true, message: '分类描述不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            // this.getMppDictCategoryList();
        },
        methods: {
            init(){
                this.getMppDictCategoryList();
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMppDictCategoryList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppDictCategoryList = [];
            },
            resetDialog() {
                this.mppDictCategoryState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      categoryName: '', //分类名称
                      categoryDesc: '', //分类描述
                      sort: '', //排序
                };
                this.getMppDictCategoryList();
            },
            closeDialog() {
                this.showDialog = false
                this.mppDictCategory = {
                      id: '', //ID
                      categoryName: '', //分类名称
                      categoryDesc: '', //分类描述
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.mppDictCategoryState == 'add') {
                    this.$refs.mppDictCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/dictcategory/add`,{ ...this.mppDictCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppDictCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mppDictCategoryState == 'edit') {
                    this.$refs.mppDictCategoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/dictcategory/edit`,{ ...this.mppDictCategory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppDictCategoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMppDictCategory() {
                this.showDialog = true;
                this.mppDictCategoryState = 'add';
            },
            checkMppDictCategory(mppDictCategoryId) {
                console.log(mppDictCategoryId);
                this.currentMppDictCategoryId = mppDictCategoryId;

                this.getMppDictCategoryById();
                this.showDialog = true;
                this.mppDictCategoryState = 'check';
            },
            editMppDictCategory(mppDictCategoryId) {
                console.log('mppDictCategory', mppDictCategoryId);
                if (mppDictCategoryId) {
                    this.currentMppDictCategoryId = mppDictCategoryId;
                    this.getMppDictCategoryById();
                } else {
                    this.mppDictCategory = { ...this.mppDictCategory, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppDictCategoryState = 'edit';
            },
            deleteMppDictCategory(mppDictCategoryId) {
                let ids = '';
                if (mppDictCategoryId) {
                    ids = mppDictCategoryId;
                } else {
                    ids = this.multipleSelection.map((mppDictCategory) => mppDictCategory.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/dictcategory/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppDictCategoryList();
                                this.getMppDictCategoryList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppDictCategoryList() {
                this.resetMppDictCategoryList();
                this.getMppDictCategoryList();
            },
            getMppDictCategoryList(query = {}) {
                this.loading = true;
                get(`/mpp/dictcategory/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppDictCategoryList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMppDictCategoryById() {
                get(`/mpp/dictcategory/get`,{ id: this.currentMppDictCategoryId }).then((res) =>{
                    if(res.success){
                      this.mppDictCategory = { ...this.mppDictCategory, ...res.mppDictCategory };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppDictCategoryList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/dictcategory/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/dictcategory/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/dictcategory/importData`,formData);
              this.refreshMppDictCategoryList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppDictCategoryList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppDictCategoryList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>